import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'

const Tile = ({ event }) => {
  const { name, slug, date, promotion, hidePromotion, logo } = event
  return (
    <Wrapper>
      <Link to={`/event/${slug.current}`}>
        <GatsbyImage
          className="tile-logo"
          imgClassName="tile-logo-image"
          image={logo?.asset?.gatsbyImageData}
          alt={''}
          loading="lazy"
          layout="constrained"
        />
        <Name>
          {hidePromotion ? `` : promotion.abbreviation} {name}
        </Name>
        <Date>{date}</Date>
      </Link>
    </Wrapper>
  )
}

const Wrapper = styled.article`
  .tile-logo {
    z-index: 1;
    position: relative;
    border-radius: var(--radius-2);
    border: 1px solid var(--color-surface4);
    transition: border 250ms;
    box-shadow: var(--shadow-3);

    &:hover {
      border: 1px solid var(--color-primary);
    }
  }

  a {
    text-decoration: none;
    transition: color 250ms;

    &:hover,
    &:focus {
      color: var(--color-secondary);
    }
  }
`

const Name = styled.h3`
  z-index: 10;
  position: relative;
  display: block;
  margin-top: 0.25em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--font-size-0);
  line-height: 1.6;

  @media (min-width: 768px) {
    font-size: var(--font-size-1);
    line-height: 1.8;
  }
`

const Date = styled.p`
  color: var(--color-text2);
  font-size: var(--font-size-0);
  line-height: 1;
  font-weight: 500;
  transform: translateY(-2px);
`

export default Tile
